export const SET_SERVICE = 'setService'
export const SET_SERVICES = 'setServices'
export const RESET_STATE_ITEM = 'resetStateItem'
export const RESET_STATE = 'resetState'

export const SET_FILTER_SETTINGS = 'setFilterSettings'
export const FILTERS_RESET_STATE = 'resetFilterState'
export const SET_FILTER_DATA = 'setFilterData'
export const SET_FILTER_SELECTED = 'setFilterSelected'
export const SET_SEARCH_TIME = 'setSearchTime'

export const SET_ORGANIZATION = 'setOrganization'
export const SET_LOCATION = 'setLocation'
export const SET_LOCATIONS = 'setLocations'

export const SET_STORE_QUERY_PARAMS = 'setStoreQueryParams'
